import React from 'react'
import ReactDOM from 'react-dom'

import Main from './main'

const el = document.getElementById('app')
ReactDOM.render(<Main />, el)



/** WEBPACK FOOTER **
 ** ./client/app/index.js
 **/